<template>
  <div class="page-wrapper pt-3 px-6">
    <!-- Page Header -->
    <page-header title="Principal" icon="mdi-home" :breadcrumbs="breadcrumbs.items"></page-header>
    <v-card class="mx-auto mt-3" :loading="isLoadingData">
      <v-card-title>Bienvenido a WindReports</v-card-title>
      <v-card-text>Plataforma para la gestión de informes de inspección y reparación de palas.</v-card-text>
    </v-card>

    <v-container class="mt-6">
      <map-component v-if="authUser" />
    </v-container>
  </div>
</template>

<script>
import Util from "@/util/index";
import PageHeader from "@/components/PageHeader";
import MapComponent from '@/components/MapComponent.vue';

export default {
  components: {
    PageHeader,
    MapComponent
  },
  data() {
     return {
      authUser: false,
      isLoadingData: false,
      breadcrumbs: {
        items: [
          {
            text: "Principal",
            disabled: true
          }
        ]
      }
    };
  },
  computed: {
    farms () {
      return this.$store.state.farms.wind_farms
    },
  },
  methods: {
    loadFarms () {
      this.isLoadingData = true;
      this.$store.dispatch('farms/getFarms')
        .then(() => {
          this.authUser = true
        })
        .catch(error => {
          if (error.response.status === 403 ) {
            // this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
            //   color: "error",
            //   x: "center",
            //   y: "top",
            //   icon: "mdi-information",
            //   timeout: 0,
            //   showClose: true,
            //   closeText: "Cerrar"
            // });
            // this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "Ha ocurrido un error cargando los parques eólicos."
            Util.showErrorToast(this, error, errorToastMessage);
          }
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    }
  },
  created() {
    this.loadFarms()
  }
};
</script>

